<template>
  <div class="quality-disclaimer">
    <div class="quality-disclaimer__levels">
      <div>
        <h6 class="">
          {{ $t('INBOX_MGMT.QUALITY.LEVELS.TITLE') }}
        </h6>
        <ul class="quality-disclaimer__levels-list">
          <li class="quality-disclaimer__level">
            <span class="quality-disclaimer__level-text" v-dompurify-html="($t('INBOX_MGMT.QUALITY.LEVELS.HIGH'))" />
          </li>
          <li class="quality-disclaimer__level">
            <span class="quality-disclaimer__level-text" v-dompurify-html="($t('INBOX_MGMT.QUALITY.LEVELS.MEDIUM'))" />
          </li>
          <li class="quality-disclaimer__level">
            <span class="quality-disclaimer__level-text" v-dompurify-html="($t('INBOX_MGMT.QUALITY.LEVELS.LOW'))" />
          </li>
          <li class="quality-disclaimer__level">
            <span class="quality-disclaimer__level-text" v-dompurify-html="($t('INBOX_MGMT.QUALITY.LEVELS.NA'))" />
          </li>
        </ul>
      </div>
      <hr/>
      <div>
        <p>
          {{ $t('INBOX_MGMT.QUALITY.LEVELS.DYNAMIC_NOTE') }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="quality-disclaimer__toggle"
      @click="showDetails = !showDetails"
    >
      <span>{{ toggleLabel }}</span>
      <fluent-icon
        :icon="showDetails ? 'chevron-up' : 'chevron-down'"
        size="16"
      />
    </button>

    <div v-show="showDetails" class="quality-disclaimer__details">
      <div class="quality-disclaimer__section">
        <h6 class="quality-disclaimer__title">
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.ABOUT_TITLE') }}
        </h6>
        <p>
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.ABOUT_BODY') }}
        </p>
      </div>

      <div class="quality-disclaimer__section">
        <h6 class="quality-disclaimer__title">
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.EVAL_TITLE') }}
        </h6>
        <p>
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.EVAL_BODY') }}
        </p>
        <ul class="quality-disclaimer__eval-list">
          <li
            v-for="index in 7"
            :key="`quality-eval-li-${index}`"
          >
            {{ $t(`INBOX_MGMT.QUALITY.DISCLAIMER.EVAL_LI${index}`) }}
          </li>
        </ul>
      </div>

      <div class="quality-disclaimer__section">
        <h6 class="quality-disclaimer__title">
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.META_TITLE') }}
        </h6>
        <p>
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.META_BODY') }}
        </p>
      </div>

      <div class="quality-disclaimer__section">
        <h6 class="quality-disclaimer__title">
          {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.IMPROVE_TITLE') }}
        </h6>
        <div class="quality-disclaimer__tips">
          <div class="quality-disclaimer__tip">
            <h6 class="quality-disclaimer__tip-title">
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_ENGAGE_TITLE') }}
            </h6>
            <p>
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_ENGAGE_BODY') }}
            </p>
          </div>
          <hr class="quality-disclaimer__tip-divider" />
          <div class="quality-disclaimer__tip">
            <h6 class="quality-disclaimer__tip-title">
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_OPTIN_TITLE') }}
            </h6>
            <p>
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_OPTIN_BODY') }}
            </p>
          </div>
          <hr class="quality-disclaimer__tip-divider" />
          <div class="quality-disclaimer__tip">
            <h6 class="quality-disclaimer__tip-title">
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_OPTOUT_TITLE') }}
            </h6>
            <p>
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_OPTOUT_BODY') }}
            </p>
          </div>
          <hr class="quality-disclaimer__tip-divider" />
          <div class="quality-disclaimer__tip">
            <h6 class="quality-disclaimer__tip-title">
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_CONTENT_TITLE') }}
            </h6>
            <p>
              {{ $t('INBOX_MGMT.QUALITY.DISCLAIMER.TIP_CONTENT_BODY') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QualityDisclaimer',
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    toggleLabel() {
      return this.showDetails
        ? this.$t('INBOX_MGMT.QUALITY.DISCLAIMER.HIDE_MORE')
        : this.$t('INBOX_MGMT.QUALITY.DISCLAIMER.SHOW_MORE');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.quality-disclaimer {
  width: 100%;
  margin-top: $space-large;
  padding: 3.6rem 10rem;
  background: #E0E0E0;
  border-radius: 10px;

  p{
    white-space: pre-line;
    margin: 0;
  }

  hr{
    height: 56px;
    width: 1px;
    background-color: #000000;
    border: 0;
    margin: 0;
    flex-shrink: 0;
  }
}

.quality-disclaimer__levels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $space-large;

  > div {
    flex: 1;
  }
}

.quality-disclaimer__levels-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.quality-disclaimer__level {
  display: flex;
  align-items: flex-start;
  gap: $space-small;
  margin-bottom: $space-small;

  &:last-child {
    margin-bottom: 0;
  }
}

.quality-disclaimer__level-dot {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  margin-top: 0.2rem;
  border-radius: 50%;
}

.quality-disclaimer__level-text {
  font-size: var(--font-size-small);
  line-height: 1.6;

  strong {
    font-weight: var(--font-weight-medium);
  }
}

.quality-disclaimer__eval-list {
  margin-top: $space-small;
}

.quality-disclaimer__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $space-micro;
  width: 100%;
  margin: $space-normal auto 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1170C6;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  cursor: pointer;

  &:hover {
    color: var(--w-600);
  }

  &:focus-visible {
    outline: 2px solid #1170C6;
    outline-offset: 2px;
    border-radius: var(--border-radius-small);
  }
}

.quality-disclaimer__details {
  max-width: 100%;
  margin-top: $space-large;
  padding-top: $space-large;
  border-top: 1px solid var(--s-100);
}

.quality-disclaimer__section {
  margin-bottom: $space-large;

  &:last-child {
    margin-bottom: 0;
  }
}

.quality-disclaimer__title {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-bold);
  margin: 0 0 $space-smaller;
  line-height: 1.4;
}

.quality-disclaimer__tip-title {
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  margin: 0 0 $space-micro;
  line-height: 1.4;
}

.quality-disclaimer__tips {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: $space-large;
}

.quality-disclaimer__tip {
  flex: 1;
}

.quality-disclaimer__tip-divider {
  height: auto;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.15);
  border: 0;
  margin: 0;
  flex-shrink: 0;
  align-self: stretch;
}

@media (max-width: 768px) {
  .quality-disclaimer__tips {
    flex-direction: column;
    gap: $space-normal;

    .quality-disclaimer__tip-divider {
      display: none;
    }
  }
}

@media (max-width: 640px) {
  .quality-disclaimer__levels {
    flex-direction: column;
    align-items: flex-start;
    gap: $space-normal;

    hr {
      display: none;
    }
  }
}
</style>
